// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__6Mzfv","rotate":"Loader_rotate__j+YFE"};